import React, {Component} from 'react';
import qs from 'qs';
import AirbnbApi from '../../api/Airbnb';
export class AirbnbGetAppToken extends Component {
    render() {
        const params = qs.parse(this.props.location.search.substring(1));
        if (params.code !== undefined) {
            AirbnbApi.initAuth(params.code);
            return <span>Ok</span>
        }

        window.location.href = "https://www.airbnb.com/oauth2/auth?client_id=8l6t4hj37z5v7s3kn6jyb0n01&redirect_uri=https://rentamania.es/tech/airbnb&scope=vr,property_management,messages_read,messages_write";
        return <span/>;
    }
}



// WEBPACK FOOTER //
// ./src/components/Airbnb/AirbnbGetAppToken.js